"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.presignMessagePrefix = void 0;
exports.presignMessagePrefix = '\x19Ethereum Signed Message:\n';
//# sourceMappingURL=strings.js.map